/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_BackstageInputs */

const en_nav_backstage = /** @type {(inputs: Nav_BackstageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backstage`)
};

/**
* | output |
* | --- |
* | "Backstage" |
*
* @param {Nav_BackstageInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_backstage = /** @type {((inputs?: Nav_BackstageInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_BackstageInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_backstage(inputs)
});